import React from 'react';
import { Alert } from 'react-bootstrap';

export interface ValidationSummaryProps {
   errors?: Array<string>;
}

type State = { show: boolean }

export class ValidationSummary extends React.Component<ValidationSummaryProps, State>{

   state: State = { show: true }

   handleDismiss = () => {
      this.setState({ show: false })
   }

   componentDidUpdate = (prevProps: ValidationSummaryProps) => {
      if (this.props.errors !== prevProps.errors) {
         const hasErrors = this.props.errors != null && this.props.errors.length > 0;
         this.setState({ show: hasErrors });
      }
   }

   render() {

      const errorMessages = this.props.errors || [];
      if (errorMessages.length && this.state.show) {
         return (
            <Alert bsStyle="danger" onDismiss={this.handleDismiss}>
               <p>
                  The following errors have occurred:
                  <ul>
                     {errorMessages.map(errorMessage => <li key={errorMessage}>{errorMessage}</li>)}
                  </ul>
               </p>
            </Alert>
         );
      }
      return null;
   }
}

(ValidationSummary as any).displayName = 'ValidationSummary';